$(document).ready(function() {
  var filterBar = $(".article-sidebar-inner");
  if (filterBar.length) {
    var filterBarTopPosition = filterBar.offset().top;
  }else {
  } 
  $(window).on("scroll", function() {
      var scrollPosition = $(window).scrollTop();
      var contentHeight = $('.article-wrapper .article').innerHeight();
      var sidebarHeight = $('.article-sidebar-inner').height();
      //var sidebarBottomPos = contentHeight - sidebarHeight; 
      var sidebarBottomPos = contentHeight; 

      if (scrollPosition >= filterBarTopPosition) {
          filterBar.addClass("fixed");
      } else {
          filterBar.removeClass("fixed");
      }
      if (scrollPosition >= sidebarBottomPos) {
        	$('.article-sidebar-inner').addClass('bottom');
    	} else {
        	$('.article-sidebar-inner').removeClass('bottom');
    	}
  });

  // Blog post page sidebar
  $(".featured-product-slider").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: false,
    arrows: true,
    autoplay: true,
    autoplaySpeed: 10000
  });
});